<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import JsrybgBrowse from "./JsrybgBrowse";
import JsrybgEdit from "./JsrybgEdit";
import JsrybgForm from "./JsrybgForm";
export default {
    name: "jsrybg",
    components: { JsrybgBrowse, JsrybgEdit, JsrybgForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "JsrybgEdit";
            } else if (this.editProps.showForm === true) {
                return "JsrybgForm";
            } else {
                return "JsrybgBrowse";
            }
        }
    }
};
</script>
